import { render, staticRenderFns } from "./crudCash.vue?vue&type=template&id=5a0f3460"
import script from "./crudCash.vue?vue&type=script&lang=js"
export * from "./crudCash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports